const detailCategories = {
  questionDelete: "Are you sure you want to delete this category?",
  warning: "This action cannot be undone.",
  successDeleted: "Category deleted",
  errorDeleted: "Error deleting category",
  cancel: "Cancel",
  confirm: "Confirm",
  delete: "Delete",
};

export default detailCategories;
